import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke051aRequest, Sgke051aResponse, Sgke051aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke051aService {
  /**
   * コンストラクタ
   * @param {Sgke051aService} sgke051aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke051aService
   */
  constructor(private sgke051aService: Sgke051aService
    , private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 初期表示API呼び出し
   *
   * @param {*} request
   * @memberof UsedSgke051aService
   */
  doSgke051a(request: Sgke051aRequest): Observable<Sgke051aResponse> {

    return this.sgke051aService.ke10RSGKE051APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE051A');
          return throwError(err.message);
        }
        )
      );
  }
}
